module.exports = __webpack_public_path__ + "img/Unknown.8e407b17.svg";